import useValidationSchema from "hooks/useValidationSchema";
import { Form, Field } from "react-final-form";
import { SlotsTemplatesFilterProps } from "./types";
import "./slotsTemplatesFilter.scss";
import { validationSchema } from "./schemas";
import { SlotTemplatesFilterType } from "reducers/types/slotTemplates";
import { VALIDATION_REGEX } from "utils/constants";
import "./i18n";
import { useTranslation } from "react-i18next";
import DropdownFilter from "component/dropdownFilter/DropdownFilter";
import {
  AutoComplete,
  Button,
  MultiSelectInput,
  SelectInput,
  TextInput,
} from "@pickit/pickit-components";

const SlotsTemplatesFilter = ({
  id,
  regions,
  workzones,
  shifts,
  filters,
  fetchingWorkzones,
  testId,
  resetWorkzones,
  onSubmit,
  onUpdateWorkzones,
  setActualRegion,
  setCollapseTable,
}: SlotsTemplatesFilterProps) => {
  const { t } = useTranslation();
  return (
    <DropdownFilter
      title={t("global:filter")}
      testId={testId}
      collapseTable={setCollapseTable}
    >
      <div className="container-fluid slots-templates-card-container">
        <div className="container-row">
          <div className="container-col pl-0">
            <div
              id={id}
              className="container-slots-templates-filter-fluid slots-filter-form-container"
            >
              <Form
                onSubmit={(values: SlotTemplatesFilterType) => onSubmit(values)}
                initialValues={filters}
                mutators={{
                  resetWorkzones: ([field, value], state, { changeValue }) => {
                    changeValue(state, "workzone", () => "");
                    if (!value || !value.id) {
                      resetWorkzones();
                      setActualRegion("");
                    }
                  },
                }}
                validate={useValidationSchema(validationSchema)}
              >
                {({ handleSubmit, form, values, invalid }) => (
                  <form
                    className="container-slots-templates-filter-row"
                    onSubmit={handleSubmit}
                  >
                    <div className="container-slots-templates-filter-col-1">
                      <Field
                        type="text"
                        id={id + "-code"}
                        name="code"
                        component={TextInput}
                        className="Admin-Pickers-input"
                        label={t("filterTemplates:codeLabel")}
                        placeholder={t("filterTemplates:codePlaceholder")}
                        maxLength={6}
                        pattern={VALIDATION_REGEX.lettersAndNumbers}
                        testId={`${testId}-code`}
                      />
                    </div>
                    <div className="container-slots-templates-filter-col-1">
                      <Field
                        type="text"
                        id={id + "-region"}
                        name="region"
                        onChange={form.mutators.resetWorkzones}
                        className="Admin-Pickers-input"
                        label={t("filterTemplates:regionLabel")}
                        placeholder={t("filterTemplates:regionPlaceholder")}
                        options={regions}
                        testId={`${testId}-region`}
                      >
                        {(props: any) => <AutoComplete {...props} />}
                      </Field>
                    </div>
                    <div className="container-slots-templates-filter-col-1">
                      <Field
                        type="text"
                        id={id + "-workzone"}
                        name="workzone"
                        className="Admin-Pickers-input"
                        label={t("filterTemplates:workzoneLabel")}
                        placeholder={t("filterTemplates:workzonePlaceholder")}
                        disabled={workzones?.length === 0 && !values.region}
                        testId={`${testId}-workzone`}
                        options={workzones}
                      >
                        {(props: any) => (
                          <MultiSelectInput
                            {...props}
                            labelAll={t("global:allF")}
                            isLoading={fetchingWorkzones}
                            onFocus={() =>
                              onUpdateWorkzones(values.region || "")
                            }
                          />
                        )}
                      </Field>
                    </div>
                    <div className="container-slots-templates-filter-col-1">
                      <Field
                        type="text"
                        id={id + "-shift"}
                        name="shift"
                        className="Admin-Pickers-input"
                        label={t("filterTemplates:shiftLabel")}
                        placeholder={t("filterTemplates:shiftPlaceholder")}
                        options={shifts}
                        testId={`${testId}-shift`}
                      >
                        {(props: any) => (
                          <SelectInput
                            showProperty="description"
                            keyProperty="tag"
                            {...props}
                          />
                        )}
                      </Field>
                    </div>
                    <div className="container-slots-templates-filter-col-1">
                      <Field
                        type="text"
                        id={id + "-days"}
                        name="days"
                        label={t("filterTemplates:frequencyLabel")}
                        placeholder={t("filterTemplates:frequencyPlaceholder")}
                        className="Admin-Pickers-input"
                                                options={[
                          { id: 'mon', label: t('global:monday') },
                          { id: 'tue', label: t('global:tuesday') },
                          { id: 'wed', label: t('global:wednesday') },
                          { id: 'thu', label: t('global:thursday') },
                          { id: 'fri', label: t('global:friday') },
                          { id: 'sat', label: t('global:saturday') },
                          { id: 'sun', label: t('global:sunday') }
                        ]}
                        testId={`${testId}-days`}
                      >
                        {(props: any) => (
                          <MultiSelectInput
                            {...props}
                            labelAll={t("global:allF")}
                            showProperty="label"
                          />
                        )}
                      </Field>
                    </div>
                    <div className="container-slots-templates-filter-col-1 end">
                      <Button
                        label={t("global:search")}
                        type="submit"
                        iconName="search"
                        testId={`${testId}-search-button`}
                        size="large"
                        hierarchy="secondary"
                        disabled={invalid}
                      />
                    </div>
                  </form>
                )}
              </Form>
            </div>
          </div>
        </div>
      </div>
    </DropdownFilter>
  );
};

export default SlotsTemplatesFilter;
